import React, { useContext } from "react";
import { PoseLandmarker } from "@mediapipe/tasks-vision";

// Import Components
import { TitleBar, Scan } from "components/index";
import { ProcedureType, TScreen } from "api/type";
import { ScreenContext } from "contexts";
import { TImageBlobAndViewType } from "components/scan/Scan";

type ScreenScanProps = {
  selectedProcedure: ProcedureType | null;
  poseLandmarker: PoseLandmarker | "ERROR" | null;
};

const ScreenScan: React.FC<ScreenScanProps> = ({
  poseLandmarker,
  selectedProcedure,
}) => {
  const setScreen = useContext(ScreenContext)[1];

  const handleSaveImageBlobsAndViewTypes = (
    imageBlobsAndViewTypes: TImageBlobAndViewType[],
  ) => {
    window.parent.postMessage({ message: "close modal" }, "*");
    window.parent.postMessage(
      imageBlobsAndViewTypes.map((imageBlobAndViewType) => ({
        viewType: imageBlobAndViewType.viewType,
        beforeImage: imageBlobAndViewType.image,
        afterImage: null,
      })),
      "*",
    );
  };

  if (!selectedProcedure) return null;

  return (
    <div className="screen-container">
      <TitleBar
        name={"Scan"}
        centerTitle
        showLogo={false}
        onClickBackButton={() =>
          setScreen(TScreen.BODY_SCAN_INSTRUCTIONS_SCREEN)
        }
      />
      <Scan
        isScanAllPoses={true}
        poseLandmarker={poseLandmarker}
        selectedProcedure={selectedProcedure}
        handleSaveImageBlobsAndViewTypes={handleSaveImageBlobsAndViewTypes}
      />
    </div>
  );
};

export default ScreenScan;
